import { Link } from "react-router-dom";
import { categories } from "@/mocks/gossip";
import NewsletterForm from "@/components/feature/NewsletterForm";

const SITE_LINKS = [
  { label: "首页", to: "/" },
  { label: "猛料总汇", to: "/hot" },
  { label: "专题分类", to: "/topics" },
  { label: "关于我们", to: "/about" },
  { label: "常见问题", to: "/faq" },
  { label: "联系我们", to: "/contact" },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-950 text-background-200 mt-16 md:mt-24">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10 lg:gap-8">
          <div className="lg:col-span-4">
            <Link to="/" className="flex items-center gap-2.5 cursor-pointer" aria-label="看料吃瓜社首页">
              <span className="w-10 h-10 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center text-xl">
                <i className="ri-chat-smile-2-line"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">看料吃瓜社</span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-background-300/90 font-label max-w-sm">
              把分散的热点线索、时间线与前因后果整理成一份看得懂的瓜源汇总。热门大瓜、劲爆猛料、深水硬核内容持续更新，不用东翻西找。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {categories.slice(0, 3).map((item) => (
                <span
                  key={item.id}
                  className="px-2.5 py-1 text-[11px] font-label rounded-full bg-secondary-900 text-background-300 border border-secondary-800"
                >
                  {item.name}
                </span>
              ))}
            </div>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              <Link to="/" className="hover:text-accent-300 transition-colors">
                站点导航
              </Link>
            </h4>
            <ul className="space-y-2.5">
              {SITE_LINKS.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm font-label text-background-300/90 hover:text-accent-300 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              <Link to="/topics" className="hover:text-accent-300 transition-colors">
                内容线分类
              </Link>
            </h4>
            <ul className="space-y-2.5">
              {categories.map((item) => (
                <li key={item.id}>
                  <Link
                    to={`/hot?category=${item.id}`}
                    className="text-sm font-label text-background-300/90 hover:text-accent-300 transition-colors inline-flex items-center gap-2"
                  >
                    <i className={`${item.icon} text-accent-400`}></i>
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">订阅每日瓜报</h4>
            <p className="text-sm font-label text-background-300/90 leading-relaxed mb-4">
              每天一封，只挑值得看的那几条，附上信息来源与时间线。
            </p>
            <NewsletterForm />
          </div>
        </div>
      </div>

      <div className="border-t border-secondary-800">
        <div className="w-full px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs font-label text-background-400 text-center sm:text-left">
            © {new Date().getFullYear()} 看料吃瓜社 · 内容整理与来源标注站点
          </p>
          <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
            <Link
              to="/faq"
              className="text-xs font-label text-background-400 hover:text-accent-300 transition-colors"
            >
              内容原则
            </Link>
            <Link
              to="/contact"
              className="text-xs font-label text-background-400 hover:text-accent-300 transition-colors"
            >
              线索投稿
            </Link>
            <a
              href="mailto:contact@kanliaochigua.example"
              rel="nofollow"
              className="text-xs font-label text-background-400 hover:text-accent-300 transition-colors"
            >
              contact@kanliaochigua.example
            </a>
          </div>
        </div>
        <div className="w-full px-4 md:px-6 pb-6">
          <p className="text-[11px] font-label text-background-500 leading-relaxed text-center sm:text-left max-w-4xl">
            本站内容均为公开信息整理与再叙述，旨在提供可追溯的阅读参考，不含任何针对个人的主观定性。若您认为某条内容存在偏差，欢迎通过联系表单提交更正说明。
          </p>
        </div>
      </div>
    </footer>
  );
}